import Vue from 'vue'
import router from './router/index'
import store from '@/search/store'
import './main.entry.css'

const mountEl = document.querySelector('#product-search-app') as HTMLElement

const install = (mountEl: HTMLElement) => {
  if (!mountEl) {
    return false
  }
  new Vue({
    router: router,
    store,
    template: '<div><router-view :key="$route.path"></router-view></div>'
  }).$mount(mountEl)
}

install(mountEl)
